import { Component, inject, OnInit } from '@angular/core';
import { IsActiveMatchOptions, Router } from '@angular/router';
import { NavSidebarService } from './sidebar.service';
import { NavContentDynamicRowComponent } from '@mt-ng2/nav-module';

@Component({
    styles: [`
        .registration-requests-nav-link {
            padding: 5px 5px 5px 15px;
            display: block;
            font-size: 14px;
        }

        .registration-requests-nav-link > div {
            color: #333333;
        }

        .registration-requests-nav-link > .registration-requests-nav-menu-title {
            color: #333333;  
        }  

        .registration-requests-nav-menu-title {
            white-space: normal;
            text-decoration: none;
        }

        .registration-requests-nav-link:hover > div {
            color: #000000;
        }

        .registration-requests-nav-link:hover > .registration-requests-nav-menu-title {
            color: #000000;
        }

        
    `],
    template: `
        <a class="nav-item registration-requests-nav-link" [routerLink]="link">
            <ng-container class="ng-star-inserted">
                <div class="menu-img fa fa-fw fa-question"></div>
                <span [class.active]="IsRouterLinkActive" class="menu-title registration-requests-nav-menu-title">
                    Registration Requests <span>[{{count}}]</span>
                </span>
            </ng-container>
        </a>
    `,
    standalone: false
})
export class RegistrationRequestsNavComponent extends NavContentDynamicRowComponent implements OnInit {
    private router = inject(Router);
    private navSidebarService = inject(NavSidebarService);

    count: number;
    link = '/registration-requests';
    routerLinkActiveOptions: IsActiveMatchOptions = {
        paths: 'exact',
        queryParams: 'exact',
        fragment: 'ignored',
        matrixParams: 'ignored',
    };

    get IsRouterLinkActive(): boolean {
        return this.router.isActive(this.link, this.routerLinkActiveOptions);
    }

    ngOnInit(): void {
        this.navSidebarService.getPendingRegistrationRequestsCount().subscribe((value) => {
            this.count = value;
        });
    }
}
